(function () {
  'use strict';
  var PX = 'bu';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }

  var D = document, H = D.documentElement, A = 'addEventListener', R = 'removeEventListener';
  H.classList.add('bu-js');
  function still() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function phone() { return window.matchMedia ? matchMedia('(max-width: 749px)') : { matches: false }; }
  function def(n, c) { if (!customElements.get(n)) customElements.define(n, c); }
  function raf(fn) { var q = 0; return function () { if (q) return; q = requestAnimationFrame(function () { q = 0; fn(); }); }; }
  function keep(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { /* private mode: the toggle still works for this visit */ } return null; }
  function paused() { return H.hasAttribute('data-bu-pause'); }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
  /* the lit part of a moon seen from the right: p = 0 new ... 0.5 half ... 1 full (same maths as moon_d() in the sections module) */
  function phaseD(p) { var k = 1 - 2 * p; return 'M24 2A22 22 0 0 1 24 46A' + (Math.abs(k) * 22).toFixed(2) + ' 22 0 0 ' + (k > 0 ? 0 : 1) + ' 24 2Z'; }

  /* ------------------------------------------------------------------ <bu-reveal> */
  def('bu-reveal', class extends HTMLElement {
    connectedCallback() {
      var s = this;
      if (!('IntersectionObserver' in window)) { s.classList.add('is-in'); return; }
      this.io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { s.classList.add('is-in'); s.io.disconnect(); } }, { rootMargin: '0px 0px -8% 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  });

  /* ------------------------------------------------------------------ <bu-hero>: the sky glow, the Pause motion toggle, the loops */
  def('bu-hero', class extends HTMLElement {
    connectedCallback() {
      var s = this, b = this.querySelector('[data-bu-pausebtn]');
      function mark(v) { H.toggleAttribute('data-bu-pause', v); if (b) b.setAttribute('aria-pressed', v ? 'true' : 'false'); }
      mark(keep('bu-pause') === '1');
      this.upd = raf(function () {
        s.style.setProperty('--bu-m', (paused() || still() ? 0 : clamp((window.pageYOffset || 0) / ((s.offsetHeight || 700) * 0.8), 0, 1)).toFixed(3));
      });
      this.tog = function () { var v = !paused(); mark(v); keep('bu-pause', v ? '1' : '0'); s.upd(); };
      if (b) b[A]('click', this.tog);
      window[A]('scroll', this.upd, { passive: true }); window[A]('resize', this.upd, { passive: true });
      this.upd();
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-away', !e.isIntersecting); }); });
        [].forEach.call(this.querySelectorAll('.bu-loop'), function (l) { s.io.observe(l); });
      }
    }
    disconnectedCallback() {
      window[R]('scroll', this.upd); window[R]('resize', this.upd);
      if (this.io) this.io.disconnect();
    }
  });

  /* ------------------------------------------------------------------ <bu-moon>: one scroll listener for every moon on the page */
  var moons = [], lastP = -1, moonTick = raf(moonsUpdate);
  function moonsUpdate() {
    if (still() || !moons.length) return;
    var p = 0.06 + 0.94 * clamp((window.pageYOffset || 0) / Math.max(1, H.scrollHeight - window.innerHeight), 0, 1);   /* a thin crescent at the top of the page, a full moon at the bottom */
    if (Math.abs(p - lastP) < 0.003) return;
    lastP = p;
    var d = phaseD(p);
    moons.forEach(function (m) { if (m._path) m._path.setAttribute('d', d); });
  }
  def('bu-moon', class extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('is-static')) return;
      this._path = this.querySelector('.bu-ph__lt'); if (!this._path) return;
      if (!moons.length) { window[A]('scroll', moonTick, { passive: true }); window[A]('resize', moonTick, { passive: true }); }
      moons.push(this); lastP = -1; moonTick();
    }
    disconnectedCallback() {
      var i = moons.indexOf(this); if (i < 0) return;
      moons.splice(i, 1);
      if (!moons.length) { window[R]('scroll', moonTick); window[R]('resize', moonTick); }
    }
  });

  /* ------------------------------------------------------------------ <bu-dial>: the grind dial, 16 steps */
  def('bu-dial', class extends HTMLElement {
    connectedCallback() {
      var s = this, d = this.dataset, N = +d.n || 16, cur = 0, drag = false;
      var q = function (x) { return s.querySelector(x); };
      var knob = q('[data-knob]'), kg = q('[data-knobg]'), fill = q('[data-fill]'), moon = q('[data-moon]'), gr = q('[data-grounds]'), num = q('[data-num]'), st = q('[data-state]'), mi = q('[data-minus]'), pl = q('[data-plus]');
      var ticks = [].slice.call(this.querySelectorAll('[data-tick]'));
      if (!knob || !kg) return;
      function set(i, ease) {
        i = clamp(Math.round(i), 1, N); if (i === cur) return; cur = i;
        var f = (i - 1) / (N - 1), name = i <= 5 ? d.tFine : i <= 11 ? d.tMid : d.tCoarse;
        kg.classList.toggle('is-ease', !!ease);
        kg.style.transform = 'rotate(' + (-135 + 270 * f).toFixed(1) + 'deg)';
        if (fill) fill.style.strokeDashoffset = (1 - f).toFixed(4);
        ticks.forEach(function (t, k) { t.classList.toggle('is-on', k < i); });
        if (moon) moon.setAttribute('d', phaseD(0.06 + 0.94 * f));
        if (gr) { gr.style.setProperty('--bu-gr', (1 + 3.4 * f).toFixed(2) + 'px'); gr.style.setProperty('--bu-gs', (6.5 + 10.5 * f).toFixed(2) + 'px'); }
        if (num) num.textContent = i;
        if (st) st.textContent = name;
        knob.setAttribute('aria-valuenow', i); knob.setAttribute('aria-valuetext', (d.tSet || '').replace('[n]', i).replace('[state]', name));
        if (mi) mi.disabled = i <= 1; if (pl) pl.disabled = i >= N;
      }
      function at(e) {   /* the pointer's angle around the knob centre -> a step; the dead zone at the bottom keeps the nearer end */
        var r = knob.getBoundingClientRect(), a = Math.atan2(e.clientX - (r.left + r.width / 2), -(e.clientY - (r.top + r.height * 170 / 306))) * 180 / Math.PI;
        return Math.abs(a) > 135 ? (cur > N / 2 ? N : 1) : 1 + (a + 135) / 270 * (N - 1);
      }
      this._dn = function (e) { if (e.pointerType === 'mouse' && e.button !== 0) return; drag = true; knob.classList.add('is-drag'); try { knob.setPointerCapture(e.pointerId); } catch (x) { /* the move events still arrive */ } knob.focus({ preventScroll: true }); set(at(e), false); e.preventDefault(); };
      this._mv = function (e) { if (drag) set(at(e), false); };
      this._up = function () { drag = false; knob.classList.remove('is-drag'); };
      this._kd = function (e) {
        var k = e.key, v = k === 'ArrowRight' || k === 'ArrowUp' ? cur + 1 : k === 'ArrowLeft' || k === 'ArrowDown' ? cur - 1 : k === 'PageUp' ? cur + 4 : k === 'PageDown' ? cur - 4 : k === 'Home' ? 1 : k === 'End' ? N : 0;
        if (v) { e.preventDefault(); set(v, true); }
      };
      this._mi = function () { set(cur - 1, true); }; this._pl = function () { set(cur + 1, true); };
      knob[A]('pointerdown', this._dn); knob[A]('pointermove', this._mv); knob[A]('pointerup', this._up); knob[A]('pointercancel', this._up); knob[A]('keydown', this._kd);
      if (mi) mi[A]('click', this._mi); if (pl) pl[A]('click', this._pl);
      set(+d.def || 8, false); this.setAttribute('data-ready', '');
    }
  });

  /* ------------------------------------------------------------------ <bu-eta>: Order today, estimated delivery Tue, Oct 13 - Fri, Oct 16 */
  def('bu-eta', class extends HTMLElement {
    connectedCallback() {
      var v = this.querySelector('[data-eta]'); if (!v) return;
      function add(n) { var d = new Date(), w; while (n > 0) { d.setDate(d.getDate() + 1); w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
      try {
        var f = { weekday: 'short', month: 'short', day: 'numeric' };
        v.textContent = add(7).toLocaleDateString('en-US', f) + ' – ' + add(10).toLocaleDateString('en-US', f);
        this.setAttribute('data-ready', '');
      } catch (e) { /* the written fallback stays */ }
    }
  });

  /* ------------------------------------------------------------------ <bu-pill>: the sticky buy pill on phones */
  def('bu-pill', class extends HTMLElement {
    connectedCallback() {
      var s = this, t = D.querySelector('[data-bu-hero-add]');
      if (!t || !('IntersectionObserver' in window)) return;
      H.classList.add('bu-has-pill');
      this.past = false; this.on = {};
      var ends = [].slice.call(D.querySelectorAll('.site-footer, .bu-final'));
      this.io = new IntersectionObserver(function (es) { es.forEach(function (e) { s.past = !e.isIntersecting && e.boundingClientRect.top < 0; }); s.apply(); });
      this.io.observe(t);
      this.io2 = new IntersectionObserver(function (es) { es.forEach(function (e) { s.on[ends.indexOf(e.target)] = e.isIntersecting; }); s.apply(); });
      ends.forEach(function (e) { s.io2.observe(e); });
    }
    apply() {
      var end = Object.keys(this.on).some(function (k) { return this.on[k]; }, this), on = this.past && !end;
      this.classList.toggle('is-in', on);
      if (on) { this.removeAttribute('aria-hidden'); this.removeAttribute('inert'); } else { this.setAttribute('aria-hidden', 'true'); this.setAttribute('inert', ''); }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); if (this.io2) this.io2.disconnect(); H.classList.remove('bu-has-pill'); }
  });

  /* ------------------------------------------------------------------ <bu-spy>: in-page anchors, smooth scroll, "current" chip */
  function anchorId(a) {
    var h = a.getAttribute('href') || '', i = h.lastIndexOf('#');
    if (i < 0 || i === h.length - 1) return '';
    var id = h.slice(i + 1), base = h.slice(0, i).replace(/^#/, '');
    if (!id || id.charAt(0) === '/') return '';
    if (base && base !== '/' && base !== location.pathname) return '';
    return id;
  }
  def('bu-spy', class extends HTMLElement {
    connectedCallback() {
      var s = this, hero = D.querySelector('.bu-hero'); this._on = {}; this._cur = '';
      this._click = function (e) {
        if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest ? e.target.closest('a[href]') : null, id = a && anchorId(a), t = id && D.getElementById(id); if (!t || t.hidden) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + id); } catch (x) { /* the page still scrolled */ }
        if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
        try { t.focus({ preventScroll: true }); } catch (x) { /* old browsers */ }
      };
      D[A]('click', this._click);
      this.links = [];
      [].forEach.call(D.querySelectorAll('.bu-chip'), function (a) { var id = anchorId(a), el = id && D.getElementById(id); if (el) s.links.push({ a: a, id: id, el: el }); });
      /* a chip whose section is not on the home page (the offer while the store event is off or over) is hidden: no dead link, no gap */
      this._sync = function () {
        [].forEach.call(D.querySelectorAll('.bu-chip'), function (a) {
          var id = anchorId(a), el = id && D.getElementById(id), li = a.closest('li');
          var want = !el || el.hidden; if (hero && id && li && li.hidden !== want) li.hidden = want;
        });
      };
      setTimeout(this._sync, 150); window[A]('load', this._sync);
      if (hero && window.MutationObserver) { this._mo = new MutationObserver(this._sync); this._mo.observe(D.body, { attributes: true, attributeFilter: ['hidden'], subtree: true }); }   /* event-code.js hides the offer once its end date has passed: the chip follows */
      if (!this.links.length || !('IntersectionObserver' in window)) return;
      var vh = window.innerHeight;
      this._io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { s._on[en.target.id] = en.isIntersecting; });
        var cur = ''; s.links.forEach(function (l) { if (s._on[l.id]) cur = l.id; });
        if (!cur && s._cur && window.pageYOffset > 40 && !(hero && s._on[hero.id])) cur = s._cur;   /* between two sections keep the last one; back in the hero: none */
        s._cur = cur;
        s.links.forEach(function (l) { var on = l.id === cur; l.a.classList.toggle('is-current', on); if (on) l.a.setAttribute('aria-current', 'location'); else if (l.a.getAttribute('aria-current') === 'location') l.a.removeAttribute('aria-current'); });
      }, { rootMargin: '-' + Math.round(vh * 0.2) + 'px 0px -' + Math.round(vh * 0.5) + 'px 0px' });
      this.links.forEach(function (l) { s._io.observe(l.el); });
      if (hero) this._io.observe(hero);
    }
    disconnectedCallback() { D[R]('click', this._click); window[R]('load', this._sync); if (this._io) this._io.disconnect(); if (this._mo) this._mo.disconnect(); }
  });

  /* ------------------------------------------------------------------ the mini cart: bottom sheet (phone) / drawer (desktop) */
  var el = null, busy = false;
  var SVG = { x: '<path d="M6 6l12 12M18 6 6 18"/>', check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>', truck: '<path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
              lock: '<rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/>' };
  function icon(n, z) { return '<svg width="' + (z || 18) + '" height="' + (z || 18) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + SVG[n] + '</svg>'; }
  function build() {
    if (el && D.body.contains(el)) return el;
    var W = words(), P = PX + '-ui';
    el = D.createElement('div'); el.className = P; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="' + P + '__scrim" data-ui-close></div>' +
      '<aside class="' + P + '__panel" role="dialog" aria-modal="true" aria-labelledby="' + P + '-title" tabindex="-1"><div class="' + P + '__top">' +
      '<button type="button" class="' + P + '__grab" data-ui-close aria-label="' + esc(W.close) + '"><span></span></button>' +
      '<header class="' + P + '__head"><h2 class="' + P + '__title" id="' + P + '-title">' + esc(W.title) + '</h2><span class="' + P + '__count"></span>' +
      '<button type="button" class="' + P + '__x" data-ui-close aria-label="' + esc(W.close) + '">' + icon('x') + '</button></header></div>' +
      '<p class="' + P + '__added" role="status" hidden>' + icon('check', 16) + '<span>' + esc(W.added) + '</span></p>' +
      '<div class="' + P + '__body"></div><footer class="' + P + '__foot"></footer></aside>';
    el[A]('click', function (e) {
      if (e.target.closest('[data-ui-close]')) { close(); return; }
      var b = e.target.closest('[data-ui-act]'); if (!b || busy) return;
      var act = b.getAttribute('data-ui-act'), n = Number(b.getAttribute('data-qty'));
      change(b.getAttribute('data-key'), act === 'remove' ? 0 : (act === 'plus' ? n + 1 : n - 1), act);
    });
    el[A]('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } trap(el, e); });
    drag(el);
    D.body.appendChild(el); return el;
  }
  function drag(root) {   /* swipe the handle or the header down to close the sheet (phones only) */
    var panel = root.querySelector('.' + PX + '-ui__panel'), y0 = null, dy = 0, t0 = 0, mq = phone();
    function down(e) { if (!mq.matches || e.target.closest('[data-ui-act], .' + PX + '-ui__x')) return; y0 = e.clientY; dy = 0; t0 = Date.now(); panel.classList.add('is-drag'); try { e.currentTarget.setPointerCapture(e.pointerId); } catch (x) { /* optional */ } }
    function move(e) { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; }
    function up() { if (y0 === null) return; var v = dy / Math.max(1, Date.now() - t0); y0 = null; panel.classList.remove('is-drag'); panel.style.transform = ''; if (dy > 110 || (dy > 40 && v > 0.6)) close(); }
    [root.querySelector('.' + PX + '-ui__grab'), root.querySelector('.' + PX + '-ui__head')].forEach(function (h) { h[A]('pointerdown', down); h[A]('pointermove', move); h[A]('pointerup', up); h[A]('pointercancel', up); });
  }
  function change(key, qty, act) {
    busy = true; el.classList.add('is-busy');
    T().cart.change(key, Math.max(0, qty)).then(function () { return render(key, act); }).catch(function () {}).then(function () { busy = false; el.classList.remove('is-busy'); });
  }
  function isGift(i) { return i.properties && i.properties._free_product === 'true'; }
  function render(refocusKey, refocusAct) {
    var W = words(), P = PX + '-ui';
    return T().cart.get().then(function (c) {
      var body = el.querySelector('.' + P + '__body'), foot = el.querySelector('.' + P + '__foot');
      var new0 = lastAdded && lastAdded.items && lastAdded.items[0] ? lastAdded.items[0].key : null;
      el.querySelector('.' + P + '__count').textContent = c.items.length ? count(c.item_count, W) : '';
      if (!c.items.length) {
        body.innerHTML = '<div class="' + P + '__empty"><p>' + esc(W.empty) + '</p><a class="' + P + '__btn ' + P + '__btn--line" href="' + esc((T().routes && T().routes.all) || '/collections/all') + '" data-ui-close>' + esc(W.keep) + '</a></div>';
        foot.innerHTML = ''; foot.hidden = true; return;
      }
      foot.hidden = false;
      body.innerHTML = '<ul class="' + P + '__lines">' + c.items.map(function (i) {
        var v = i.variant_title && !/^default title$/i.test(i.variant_title) ? '<p class="' + P + '__meta">' + esc(i.variant_title) + '</p>' : '';
        var k = esc(i.key), ctl = isGift(i) ? '<span class="' + P + '__ro">× ' + i.quantity + '</span>' :
          '<div class="' + P + '__qty" role="group" aria-label="' + esc(W.qty) + '"><button type="button" data-ui-act="minus" data-qty="' + i.quantity + '" data-key="' + k + '" aria-label="' + esc(W.minus) + '">−</button>' +
          '<span aria-live="polite">' + i.quantity + '</span><button type="button" data-ui-act="plus" data-qty="' + i.quantity + '" data-key="' + k + '" aria-label="' + esc(W.plus) + '">+</button></div>' +
          '<button type="button" class="' + P + '__rm" data-ui-act="remove" data-qty="' + i.quantity + '" data-key="' + k + '">' + esc(W.remove) + '</button>';
        return '<li class="' + P + '__line' + (new0 && i.key === new0 ? ' is-new' : '') + '"><a class="' + P + '__pic" href="' + esc(i.url) + '" tabindex="-1" aria-hidden="true">' + pic(i.image, 80) + '</a>' +
          '<div class="' + P + '__info"><a class="' + P + '__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + v + '<div class="' + P + '__ctl">' + ctl + '</div></div>' +
          '<span class="' + P + '__price">' + money(i.final_line_price) + '</span></li>';
      }).join('') + '</ul>';
      var tpl = D.getElementById(PX + '-ev-cart');   /* the store-event ticket (the `cart` part of the shared snippet), empty while the event is off */
      if (tpl && tpl.content && tpl.content.firstElementChild) { var ev = D.createElement('div'); ev.className = P + '__ev'; ev.appendChild(tpl.content.cloneNode(true)); body.appendChild(ev); }
      foot.innerHTML = '<div class="' + P + '__sub"><span>' + esc(W.subtotal) + '</span><strong>' + money(c.total_price) + '</strong></div>' +
        '<bu-eta class="bu-eta bu-eta--line"><span class="bu-eta__ic" aria-hidden="true">' + icon('truck', 17) + '</span><span class="bu-eta__t"><span class="bu-eta__k">' + esc(W.eta) + '</span> <strong class="bu-eta__v" data-eta>' + esc(W.eta_fb) + '</strong></span></bu-eta>' +
        '<p class="' + P + '__ship">' + icon('truck') + '<span>' + esc(W.ship) + '</span></p>' +
        '<div class="' + P + '__acts"><a class="' + P + '__btn" href="' + esc(checkoutUrl()) + '">' + icon('lock') + '<span>' + esc(W.checkout) + '</span></a><a class="' + P + '__btn ' + P + '__btn--line" href="' + esc(cartUrl()) + '">' + esc(W.view_cart) + '</a></div>';
      if (refocusKey) {
        var again = el.querySelector('[data-key="' + refocusKey + '"][data-ui-act="' + refocusAct + '"]') || el.querySelector('[data-key="' + refocusKey + '"]') || el.querySelector('.' + P + '__x');
        if (again) again.focus();
      }
    });
  }
  function openUi(showAdded) {
    build(); lastFocus = D.activeElement;
    return render().then(function () {
      el.querySelector('.' + PX + '-ui__added').hidden = !showAdded;
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); H.style.overflow = 'hidden';
      var b = el.querySelector('.' + PX + '-ui__x');
      if (b && b.offsetParent) b.focus({ preventScroll: true }); else { var p = el.querySelector('.' + PX + '-ui__panel'); if (p) p.focus({ preventScroll: true }); }
    });
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); H.style.overflow = '';
    if (lastFocus && lastFocus.focus && D.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* focus is a courtesy */ } }
  }
  function afterAdd(after) {
    if (after === 'cart') return false;       /* the form asked for the cart page: let the theme go there */
    openUi(true).catch(function () {});
    return true;
  }
  function init() {
    D[A]('click', function (e) {
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest('.bu-top__cartlink'); if (!a) return;
      if (D.querySelector('boostly-cart-items')) return;   /* already on the cart page */
      e.preventDefault(); openUi(false).catch(function () {});
    });
    D[A]('keydown', function (e) { if (e.key === 'Escape' && el && el.classList.contains('is-open')) close(); });
  }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'bu';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
